export const SEO_VARIABLES = {
    
    HOME: {
        DESCRIPTION: "The Council of Leather Exports Association is an organization that represents the interests of leather manufacturers, exporters, and related businesses within a specific region or country. The association typically works to promote and support the leather industry, both domestically and internationally, by advocating for favourable trade policies, providing market information and intelligence, and offering various support services to its members.",
        KEYWORDS: "Top leather exporters in India, Leather Manufacturing industries in India, List of leather Industry, Leather Exports Association, leather exports in india, Leather industry in india, Leather Manufacturers & Exports in India, Leather Exporters, Leather Manufacturers in India, Leather product Manufacturers And Exporters, Non Leather product Manufacturers And Exporters, Leather Business in India",
        TITLE: "Top leather exporters in India | Council of leather exports"
    },

    PRODUCT_DETAILS:  {
        DESCRIPTION: "Introducing our exquisite collection of leather products, crafted with the finest materials and meticulous attention to detail. From timeless jackets and stylish handbags to durable boots and practical accessories, our leather collection offers a range of versatile and luxurious items to elevate your wardrobe and everyday essentials.",
        KEYWORDS: "Top leather exporters in india, Top leather industries in India, Leather and non Leather Product Manufacturers & Exporters, Finished Leather, Leather Footwear, Footwear Components, Leather Garments, Leather & Synthetic Goods, Saddlery & Harness, Non-leather Footwear, Fur and Leather accessories",
        TITLE: "Top  leather exporters in India | Council of leather Exports"
    },

    PRODUCT_LIST: {
        DESCRIPTION: "Introducing our exquisite collection of leather products, crafted with the finest materials and meticulous attention to detail. From timeless jackets and stylish handbags to durable boots and practical accessories, our leather collection offers a range of versatile and luxurious items to elevate your wardrobe and everyday essentials.",
        KEYWORDS: "Top leather exporters in india, Top leather industries in India, Leather and non Leather Product Manufacturers & Exporters, Finished Leather, Leather Footwear, Footwear Components, Leather Garments, Leather & Synthetic Goods, Saddlery & Harness, Non-leather Footwear, Fur and Leather accessories",
        TITLE: "Top  leather exporters in India | Council of leather Exports"
    },

    CANCELLATION_POLICY:  {
        DESCRIPTION: "",
        KEYWORDS: "",
        TITLE: "Top leather industries in India | Council of leather exports"
    },

    CONTACT_US: {
        DESCRIPTION: "Thank you for your interest in our products. For inquiries, orders, or any assistance, please feel free to contact us.",
        KEYWORDS: "Top leather exporters in india, Top leather industries in India, Leather Manufacturing industries in India, List of leather Industry, Leather Exports Association, leather exports in india, Leather industry in india, Leather Manufacturers & Exports in India, Leather Exporters, Leather Manufacturers in India, Leather product Manufacturers And Exporters, Non Leather product Manufacturers And Exporters, Leather Business in India",
        TITLE: "Top leather exporters in india | Contact us"
    },

    FAQ:  {
        DESCRIPTION: "",
        KEYWORDS: "",
        TITLE: "Top leather industries in India | Council of leather exports"
    },   
    
    PRIVACY_POLICY: {
        DESCRIPTION: "",
        KEYWORDS: "",
        TITLE: "Top leather industries in India | Council of leather exports"
    },

    RETURN_POLICY:  {
        DESCRIPTION: "",
        KEYWORDS: "",
        TITLE: "Top leather industries in India | Council of leather exports"
    },

    
    SHIPPING_DELIVERY: {
        DESCRIPTION: "",
        KEYWORDS: "",
        TITLE: "Top leather industries in India | Council of leather exports"
    },

    TERMS_AND_CONDITIONS:  {
        DESCRIPTION: "",
        KEYWORDS: "",
        TITLE: "Top leather industries in India | Council of leather exports"
    },

    ABOUT_US: {
        DESCRIPTION: "Looking for high quality leather and non-leather products? Look no further than Leatheindia, a leading Indian manufacturer known for its top-notch products and exceptional craftsmanship. Shop now!",
        KEYWORDS: "Top leather exporters in india, Top leather industries in India, Leather Manufacturing industries in India, List of leather Industry, Leather Exports Association, leather exports in india, Leather industry in india, Leather Manufacturers & Exports in India, Leather Exporters, Leather Manufacturers in India, Leather product Manufacturers And Exporters, Non Leather product Manufacturers And Exporters, Leather Business in India",
        TITLE: "Top leather exporters in india | About us"
    }

}